import React from 'react';
import { StoreReportApi } from '../api/storeReportApi';
import { Reports } from '../shared-components';

const StoreReportContainer = () => {
  const fetchStoreReport = (startDate, endDate) => {
    return StoreReportApi.getSalesByProduct(startDate, endDate).then((res) => res.data);
  };

  const fetchProductBuyers = (variantId, startDate, endDate) => {
    return StoreReportApi.getProductBuyers(variantId, startDate, endDate).then((res) => res.data);
  };

  return ( <Reports.SalesByProduct fetchStoreReport={fetchStoreReport} fetchProductBuyers={fetchProductBuyers} /> );
};

export default StoreReportContainer;